import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('PriceControl?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('PriceControl/show/'+id);
    },    
    create(params) {
        return Service().post('PriceControl/create', params);
    },
    update(id, params) {
        return Service().post('PriceControl/update/'+id, params);
    },
    delete(id) {
        return Service().post('PriceControl/delete/'+id);
    }
}